export const REFERENCES_IDS = {
    CREDITOR_NUMBER: '48865bf7-090a-4087-839b-7ee1d8e2b47a', // Leverandør nr
    PRODUCT_CATEGORY_NUMBER: '4a1426d0-79ee-4aa8-b261-a0a42fbfb0a8', // Produkt kategori nr
    CUSTOMER_NUMBER: '4cf9390c-5c6e-4d82-b1c5-22c1f9876020', // Kundenummer
    ORDER_NUMBER: 'b91883d4-bef9-4e01-beb8-aef6afa44fae', // Ordre nr
    PRODUCT_NUMBER: 'c20e9419-c67b-456d-8ead-fe3a1a77ee53', // Produkt nr
} as const;

export const ORDER_FIELDS_IDS = {
    ATTENTION: '14d49b56-5075-4d87-9b29-4bbba0d0ff40', // Attention
    REQUISITION_NUMBER: 'd77f5929-db59-4214-aef1-b049959387d5', // Rekv. nr.
    EAN: '2c06576a-d5da-11f0-8de9-0242ac120002', // EAN
} as const;

export const CONTACT_TYPES_IDS = {
    DELIVERY_ADDRESS: '2b0cafab-5f87-464b-9b95-4b156135a40d', // Leveringsadresse
    INVOICE_ADDRESS: '8bfa136b-5f35-46a9-8add-6e3f80e4b246', // Fakturaadresse
    INVOICE_META: 'bd9e9d70-2349-433c-bcbd-56ccd67042db', // Meta
} as const;
